import { render, staticRenderFns } from "./ProxiesStcp.vue?vue&type=template&id=c583efaa&"
import script from "./ProxiesStcp.vue?vue&type=script&lang=js&"
export * from "./ProxiesStcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports